// extracted by mini-css-extract-plugin
module.exports = {"root":"Schedule_root__bgdF9"};